// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pl-9";
export var arrowButtonContainer = "_pl-5";
export var arrowButtonIcon = "_pl-6";
export var carouselArrowButton = "_pl-2";
export var carouselElementContainer = "_pl-1";
export var currentSlide = "_pl-8";
export var left = "_pl-3";
export var otherSlide = "_pl-a";
export var productCarouselContainer = "_pl-0";
export var right = "_pl-4";
export var sliderOverflow = "_pl-7";